<template lang="html">
    <simple-layout
        :indicators="[
            {
                'title': getVerbose('profile_simple_layout_indicator_title'),
                'subtitle': $store.state.api.auth.user.email
            }
        ]"
        :models-loaded="true"
        :name="getVerbose('profile_simple_layout_breadcrumb')"
        :class="{'simple-lyout-no-margin': darkMode}"
    >
        <div
            v-loading="user == undefined"
            :class="{'dark-theme': darkMode}"
            class="profile-container"
        >
            <div
                v-if="user"
                class="profile"
            >
                <hr v-if="windowWidth > 768">
                <p class="date-joined">
                    {{ getVerbose('profile_arrival_date') }} {{ user.creation_date | moment('YYYY-MM-DD') }}
                </p>
                <hr>

                <h3>{{ getVerbose('profile_identity') }}</h3>
                <form-update-profile
                    ref="formUpdateProfile"
                    :user="user"
                ></form-update-profile>

                <div :class="windowWidth > 768 ? 'button-to-right' : 'button-to-center'">
                    <el-button
                        type="primary"
                        @click="saveProfileModifications"
                    >
                        {{ getVerbose('profile_save_button') }}
                    </el-button>
                </div>

                <div v-if="enableManageNotifications && scopeModelKeyDefined">
                    <hr>
                    <h3>{{ getVerbose('profile_manage_notifications') }}</h3>

                    <form-manage-notifications
                        ref="formManageNotifications"
                        :user="user"
                        :filterScopes="filterFunction"
                    ></form-manage-notifications>

                    <div :class="windowWidth > 768 ? 'button-to-right' : 'button-to-center'">
                        <el-button
                            type="primary"
                            @click="saveNotificationsModifications"
                        >
                            {{ getVerbose('profile_save_button') }}
                        </el-button>
                    </div>
                </div>

                <div v-if="userPasswordChangeable">
                    <hr>
                    <h3>{{ getVerbose('profile_change_password_title') }}</h3>

                    <form-change-password
                        ref="formChangePassword"
                        :email="user.email"
                        :buttonText="getVerbose('profile_change_password_button')"
                        alignButton="right"
                    ></form-change-password>

                </div>
            </div>
            <span v-else>{{ getVerbose('profile_loading') }}</span>
        </div>
    </simple-layout>
</template>

<script>
import PageHeader from '../../partials/PageHeader.vue';
import FormChangePassword from '../../auth/FormChangePassword.vue';
import FormUpdateProfile from './profile-form.vue';
import FormManageNotifications from './notifications-form.vue';
import {mapGetters} from 'vuex';

export default {
    components: {
        PageHeader,
        FormChangePassword,
        FormUpdateProfile,
        FormManageNotifications,
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'burgerMenuAllowedAndClosed',
            'enableManageNotifications',
            'getScopeModelKey',
            'getVerbose',
            'darkMode',
        ]),
        windowWidth() {
            return window.innerWidth;
        },
        user(){
            return this.$store.getters.currentUser;
        },
        scopeModelKeyDefined() {
            return this.getScopeModelKey.model !== '' && this.getScopeModelKey.key !== '';
        },
        userPasswordChangeable() {
            return this.$store.getters.userPasswordChangeable();
        }
    },
    watch:{
    },
    mounted(){
    },
    methods: {
        filterFunction(item) {
            return item.enable_notification;
        },
        changePassword() {
            this.$refs.formChangePassword.confirm();
        },
        saveProfileModifications() {
            this.$refs.formUpdateProfile.saveProfileModifications();
        },
        saveNotificationsModifications() {
            this.$refs.formManageNotifications.saveNotificationsModifications();
        },
    },
};
</script>

<style lang="less">
.simple-lyout-no-margin{
    .simple-layout-main{
        margin: 0;
    }
}
.profile-container {
    display: flex;
    justify-content: center;
    background: #eee !important;
    margin: 15px 0px;

    &.dark-theme{
        margin-top: 0 !important;
        background: #111111 !important;
        color: #bbb;
        .profile {
            background-color: #222 !important;
            color: #bbbbbb;
        }
        .el-form-item{
            text-align: left;
            margin-bottom: 25px;
            .ns-time-picker{
                margin-top: 7px;
                input{
                    height: 28px;
                }
                .el-input-group__append{
                    background-color: #444;
                    color: #bbb;
                    border-color: #444;
                }
                .is-disabled {
                    .el-input-group__append{
                        background-color: #111;
                        color: #bbb;
                        border-color: #111;
                    }

                }
            }
            .el-select, .el-autocomplete{
                width: 100%;

                .el-select__tags{
                    .el-tag{
                        background-color: #333 !important;
                        border-color: #333 !important;
                        color: #bbb !important;
                        .el-tag__close.el-icon-close {
                            background-color: #bbb !important;
                        }
                    }
                }
            }
            .el-form-item__label{
                margin: 0;
                font-family: roboto-light;
                font-weight: normal;
                color: #bbb;
            }
            .el-input{
                line-height: 12px !important;
            }
            .el-input-number{
                .el-input-number__decrease, .el-input-number__increase{
                    background: #444;
                    color: #fff;
                    border-color: #777;
                }
            }
            input, textarea{
                background-color: #444;
                border: none;
                color: #fff;
                line-height: 12px !important;
                &::placeholder{
                    color: #222;
                    opacity: 1;
                }
                &::placeholder{
                    color: #444 !important;
                    opacity: 1;
                }
                &:disabled{
                    background-color: #111 !important;
                }
            }
            input:disabled + .el-input__suffix i{
                color: #444 !important;

            }
        }
    }

    .profile {

        padding: 25px 40px;
        width: 100%;
        margin-top: 0;
        @media (min-width: 768px) {
            margin-top: 40px;
            padding: 25px 40px;
            width: 70%;
        }
        h2 {
            text-align: center;
        }
        .date-joined {
            text-align: center;
        }

        .button-to-right {
            width: 100%;
            display: flex;
            justify-content: flex-end;
        }
        .button-to-center {
            width: 100%;
            display: flex;
            justify-content: center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/user-profile/profile.vue